export default "__VITE_ASSET__hixGX0Ww__"